module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetLow.d284057.jpg";